
function RemoveAnyDisplayStyles(listCount) {
    for (var i = 0; i < listCount; i++) {
        document.getElementById("job-offer-mvz-" + i).style.display = "flex";

        document.getElementById("job-offer-mvz-" + i).classList.remove('d-flex');
        document.getElementById("job-offer-mvz-" + i).classList.remove('d-none');
    }
}

function TeaserIsNotDisplayed(i) {
    document.getElementById("job-offer-mvz-" + i).style.setProperty("display", "none", "important");

    document.getElementById("job-offer-mvz-" + i).classList.add('d-none');
}

function TeaserIsDisplayed(i, filteredVisibleTeaserCount) {
    document.getElementById("job-offer-mvz-" + i).style.display = "flex";

    if (filteredVisibleTeaserCount > 5) {
        document.getElementById("job-offer-mvz-" + i).classList.add('d-none');
    }
    else {
        document.getElementById("job-offer-mvz-" + i).classList.add('d-flex');
    }
}

function ShowTeasersByFilter(location, listCount) {
    RemoveAnyDisplayStyles(listCount);

    var filteredVisibleTeaserCount = 0;

    for (var i = 0; i < listCount; i++) {
        if (document.getElementById("job-offer-mvz-place-" + i).innerText.trim() == location.trim()) {
            filteredVisibleTeaserCount = filteredVisibleTeaserCount + 1;
            TeaserIsDisplayed(i, filteredVisibleTeaserCount);
        }
        else {

            TeaserIsNotDisplayed(i);
        }
    }

    return filteredVisibleTeaserCount;
}

function FilterByLocationJobOffersMvz(location, listCount) {

    var filteredVisibleTeaserCount = ShowTeasersByFilter(location, listCount);

    document.getElementById("locationDropdownMVZ").innerText = location;

    var a = document.getElementById('don-jobOffers-load-more');

    if (filteredVisibleTeaserCount > 5) {
        a.children[0].innerText = filteredVisibleTeaserCount - 5;
        a.parentElement.classList.add('d-flex');
        a.parentElement.classList.remove('d-none');
    }
    else {
        a.children[0].innerText = 0;
        a.parentElement.classList.remove('d-flex');
        a.parentElement.classList.add('d-none');
    }

    /*HideShowMoreTeasers(listCount);*/
}

function RemoveFilterJobOffers(listCount) {
    RemoveAnyDisplayStyles(listCount);

    document.getElementById("locationDropdownMVZ").innerText = "Alle Orte";

    for (var i = 0; i < 5; i++) {
        document.getElementById("job-offer-mvz-" + i).classList.add('d-flex');
        document.getElementById("job-offer-mvz-" + i).classList.remove('d-none');
    }
    for (var i = 5; i < listCount; i++) {
        document.getElementById("job-offer-mvz-" + i).classList.remove('d-flex');
        document.getElementById("job-offer-mvz-" + i).classList.add('d-none');
    }

    if (listCount > 5) {
        var a = document.getElementById('don-jobOffers-load-more');

        a.children[0].innerText = listCount - 5;
        a.parentElement.classList.add('d-flex');
        a.parentElement.classList.remove('d-none');
    }
    else {
        a.children[0].innerText = 0;
        a.parentElement.classList.remove('d-flex');
        a.parentElement.classList.add('d-none');
    }
}

(function (window, document, jQuery, undefined) {
    // map jQuery to local var
    var $ = jQuery.noConflict();

    // get list
    var $jobOffersTeaserLists = $('.job-offers-mvz__list');

    // btn click handler
    $jobOffersTeaserLists.find('.don-btn-load-more').on('click', function () {

        // show next teasers
        var rowId = $(this).data('for');
        var more = $(this).data('more');
        var myTeasersToAdd = $('#' + rowId)
            .children('.d-none');

        var addedTeasers = 0;
        for (i = 0; i < myTeasersToAdd.length && addedTeasers < 5; i++) {
            if (myTeasersToAdd[i].style.display != "none") {
                myTeasersToAdd[i].classList.remove('d-none');
                addedTeasers = addedTeasers + 1;
            }
        }

        // change teasers left counter        
        var $counter = $(this).children('span').first();
        var currentCount = $counter.text();
        var newCount = currentCount - more;
        if (newCount <= 0) {
            $(this).parent().removeClass('d-flex');
            $(this).parent().addClass('d-none');
        } else {
            $counter.text(newCount);
        }
    });

})(window, document, jQuery);